export const notPaid = 'not_paid'
export const selectbalePackageOptions = ['ID']
export const packageData = (dataList: any) => {
  const data = dataList?.map((e: any) => {
    return {
      id: e?.id,
      name: e?.name,
      partner_id: e?.partner_id?.id,
      partner_name: e?.partner_id?.name,
      partner_uhid: e?.partner_id?.ref,
      partner_mobile: e?.partner_id?.phone,
      invoice_date: e?.invoice_date,
      invoice_time: e?.invoice_date_time,
      payment_status: e?.payment_state,
      ref: e?.ref,
      state: e?.state,
      amount_total: e?.amount_total,
      invoice_name: e?.invoice_line_ids?.[0]?.name,
      thop_user_id: e?.thop_user_id,
      thop_user_name: e?.thop_user_name,
    }
  })
  return data ?? []
}
